export class Result<T, E = Error> {
	private constructor(
		private readonly _value: T | undefined,
		private readonly _error: E | undefined,
	) {}

	// Constructors
	static ok<T>(value: T) {
		return new Result(value, undefined);
	}
	static err<T, E = Error | string>(error: E) {
		return new Result<T, Error>(
			undefined,
			error instanceof Error ? error : new Error(String(error)),
		);
	}

	// State
	public get ok(): boolean {
		return this._error === undefined;
	}
	public get errored(): boolean {
		return !this.ok;
	}

	// Accessors
	public get value(): T {
		if (!this.ok) {
			throw new Error(
				`Result: Tried to access error result as value. Original error: ${this._error}`,
			);
		}
		return this._value as T;
	}
	public get getError(): E {
		return this._error;
	}
	public getOr(defaultValue: T): T {
		return this.ok ? (this._value as T) : defaultValue;
	}
	public getOrElse(fn: () => T): T {
		return this.ok ? (this._value as T) : fn();
	}
	public assert(): void {
		if (!this.ok) throw this._error;
	}
}
